export const sidebar_items = {
    rawabat_items: [
        {
            id: "1",
            name: "أكاديمية سلة",
            image: "/images/sidebar/diagonal-arrow.svg",
            link: "https://academy.salla.com/",
        },
        {
            id: "2",
            name: "مركز المساعدة",
            image: "/images/sidebar/diagonal-arrow.svg",
            link: "https://help.salla.sa/",
        },
        {
            id: "3",
            name: "مدونة سلة",
            image: "/images/sidebar/diagonal-arrow.svg",
            link: "https://salla.com/blog/",
        },
        {
            id: "4",
            name: "فيديوهات تعليمية",
            image: "/images/sidebar/diagonal-arrow.svg",
            link: "https://youtube.com/watch?v=lpmUHG_TkoM&list=PLD6ilV8p0p1PoKEcD3GLlUaPruQvxSjCb",
        },
        {
            id: "5",
            name: "تواصل معنا",
            image: "/images/sidebar/diagonal-arrow.svg",
            link: "mailto:communtiy@salla.sa",
        },
    ],
};


// =======================
// Header.jsx
// =======================
export const headerNotificationTabs = [
    { tab_name: "إعجابات وتفاعل" },
    { tab_name: "منشن" },
    { tab_name: "ردود" },
    { tab_name: "الكل" },
];

export const notificationTypeMap = {
    1: "mentioned",
    2: "replied",
    25: "reaction",
};


// =======================
// ReactionBar.jsx
// =======================
export const reactions = [
  { emoji: '❤️', label: 'heartpulse' },
  { emoji: '👍', label: '+1' },
  { emoji: '😆', label: 'laughing' },
  { emoji: '😮', label: 'open_mouth' },
  { emoji: '👏', label: 'clap' },
  { emoji: '🤗', label: 'hugs' },
  { emoji: '😘', label: 'kissing_heart' },
];

// =======================
// Search.jsx
// =======================
export const links = [
  "شروط فتح المتجر وتوثيق الحساب",
  "ماهي وثيقة العمل الحر",
  "كيفية استخراج الوثائق الحكومية"
];



// =======================
// Profile.jsx
// =======================
export const profileFilters = [
  { filter_name: "الكل", good_name: "all" },
  { filter_name: "المواضيع", good_name: "topics" },
  { filter_name: "المشاركات", good_name: "posts" },
  { filter_name: "إعجابات", good_name: "likes" },
  { filter_name: "أجوبة", good_name: "answers" },
  { filter_name: "القراءة لاحقاً", good_name: "read_later" }
]